<template>
  <div class="prescription-medicine">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <h1 class="title-pages pl-0 mb-0 mt-1">PRESCRIÇÕES</h1>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
        <v-btn @click="$bvModal.show('imprimir')" class="btn-filter m-1"
          ><i
            :class="[
              'fas fa-filter text-twenty',
              width < 600 ? 'mr-0' : 'mr-2',
            ]"
          ></i>
          <span v-if="width > 600">FILTRAR</span></v-btn
        >

        <v-btn
          v-if="group_prescription_medicines.length > 0"
          @click="handleOpenModalPrints"
          class="btn-print m-1"
        >
          <i
            :class="['fas fa-print text-twenty', width < 600 ? 'mr-0' : 'mr-2']"
          ></i>
          <span v-if="width > 600">IMPRIMIR</span>
        </v-btn>
        <v-btn
          v-if="permission('write', 'resident_medical_prescription')"
          @click="handleModalAddGroupPrescriptionMedicine"
          class="btn-add m-1"
          ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
        >
      </div>
    </div>
    <b-modal
      no-close-on-backdrop
      centered
      hide-header-close
      hide-footer
      id="imprimir"
      title="FILTRAR"
    >
      <div class="row">
        <div class="col-xl-12 pt-0">
          <h6 class="worksansr upper-text">STATUS</h6>
          <select v-model="status" class="form-control">
            <option value="PENDENTE">PRESCRIÇÕES PENDENTES</option>
            <option value="FINALIZADO">PRESCRIÇÕES FINALIZADAS</option>
            <option value="INATIVO">PRESCRIÇÕES APAGADAS</option>
            <option value="ALL">TODAS</option>
          </select>
        </div>
        <div class="col-xl-12 pt-0">
          <h6 class="worksansr upper-text">Data de início</h6>
          <input v-model="start_date" type="date" class="form-control" />
        </div>
        <div class="col-xl-12 pt-0">
          <h6 class="worksansr upper-text">Data de término</h6>
          <input v-model="end_date" type="date" class="form-control" />
        </div>
        <div class="col-xl-12">
          <ErrorsMessages :errors="errors" />
          <b-button class="btn-cancel m-1" @click="$bvModal.hide('imprimir')"
            >CANCELAR</b-button
          >
          <v-btn class="btn-filter-sidebar float-right" @click="handleFilter">
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <!-- <b-sidebar title="FILTRAR" shadow v-model="isActiveFilter">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
        <v-select
          v-model="status"
          :items="[
            { value: 'PENDENTE', text: 'PRESCRIÇÕES PENDENTES' },
            { value: 'FINALIZADO', text: 'PRESCRIÇÕES FINALIZADAS' },
            { value: 'INATIVO', text: 'PRESCRIÇÕES APAGADAS' },
            { value: 'ALL', text: 'TODAS' },
          ]"
          label="Status"
          dense
          outlined
          item-value="value"
          item-text="text"
        />

        <v-select
          v-model="quantity"
          :items="[
            { value: '5', text: 'Até 5 registros' },
            { value: '10', text: 'Até 10 registros' },
            { value: '25', text: 'Até 25 registros' },
            { value: '50', text: 'Até 50 registros' },
          ]"
          label="Mostrar"
          dense
          outlined
          item-value="value"
          item-text="text"
        />

        <v-text-field
          v-model="start_date"
          type="date"
          label="Data de início"
          outlined
          dense
        ></v-text-field>

        <v-text-field
          v-model="end_date"
          type="date"
          label="Data de término"
          outlined
          dense
        ></v-text-field>
        <ErrorsMessages :errors="errors" />

        <v-btn class="btn-filter-sidebar btn-block" @click="handleFilter">
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
        </v-btn>
      </div>
    </b-sidebar> -->
    <!-- MODAL PRINT GRUPO PRESCRIÇÃO -->
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="prints"
      title="IMPRIMIR PRESCRIÇÕES"
    >
      <div class="text-center">
        <p class="subtitles">
          <strong>
            PRESCRIÇÕES FINALIZADAS <br />
            APRAZAMENTOS FINALIZADOS</strong
          >
        </p>
      </div>
      <hr />
      <v-data-table
        dense
        v-model="prints"
        :headers="[
          {
            text: 'RESIDENTE',
            sortable: false,
            value: 'resident_name',
          },
          {
            text: 'VALIDATE',
            sortable: false,
            value: 'validate',
          },
        ]"
        :items="group_prescription_medicine_prints"
        show-select
        :footer-props="{
          'items-per-page-options': [10, 25],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:[`item.validate`]="{ item }">
          <h6 class="mb-0 worksansr">
            {{ formatDate(item.start_date, false) }}
            até
            {{ formatDate(item.end_date, false) }}
          </h6>
        </template>
      </v-data-table>
      <v-btn class="btn-print float-right mt-4" @click="handlePrints">
        <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
      >
    </b-modal>
    <!-- /MODAL PRINT GRUPO PRESCRIÇÃO -->
    <!-- MODAL GRUPO PRESCRIÇÃO -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalAddGroupPrescriptionMedicine"
      title="NOVA PRESCRIÇÃO"
    >
      <GroupMedicineCreate
        type="NORMAL"
        :resident_id="resident_id"
        :disabled_resident_id="true"
        :show_resident_id="false"
        v-on:create="handleCreateGroupPrescriptionMedicine"
      />
    </b-modal>
    <!-- /MODAL GRUPO PRESCRIÇÃO -->
    <!-- MODAL PRESCRIÇÃO MEDICAMENTO -->
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="modalAddPrescriptionMedicine"
      title="ADICIONAR MEDICAMENTO NA PRESCRIÇÃO"
    >
      <MedicineCreate
        :group_prescription_medicine="group_prescription_medicine"
        v-on:create="handleCreatePrescriptionMedicine"
        v-on:cancel="$bvModal.hide('modalAddPrescriptionMedicine')"
      />
    </b-modal>
    <!-- /MODAL PRESCRIÇÃO MEDICAMENTO -->
    <b-overlay :show="loading" opacity="0.99">
      <div class="p-5 v-clean" v-if="group_prescription_medicines.length == 0">
        <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
      </div>
      <v-expansion-panels
        v-model="panel_group_prescription_medicine"
        hover
        multiple
        tile
        class="border border-for"
      >
        <v-expansion-panel
          v-for="(
            group_prescription_medicine, key_group
          ) in group_prescription_medicines"
          :key="group_prescription_medicine.id"
        >
          <v-expansion-panel-header>
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                <h6 class="mb-0 check-text-center">
                  RESIDENTE {{ group_prescription_medicine.resident_name }}
                </h6>
                <h6 class="mb-1 worksansr check-text-center">
                  VALIDADE:
                  {{
                    formatDate(group_prescription_medicine.start_date, false)
                  }}
                  ATÉ
                  {{ formatDate(group_prescription_medicine.end_date, false) }}
                </h6>
                <h6
                  class="inline-display text-eleven mb-0 pt-1 pb-1 pl-2 pr-2 v-danger"
                  v-if="group_prescription_medicine.expired_prescription"
                >
                  PRESCRIÇÃO VENCIDA
                </h6>
              </div>
              <!-- PRESCRIÇÃO -->
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-center"
              >
                <img
                  v-if="
                    !group_prescription_medicine.finish_user ||
                    group_prescription_medicine.status == 'PENDENTE'
                  "
                  class="mr-2 no-user-photo-url"
                  :src="require('../../../../assets/user.png')"
                />
                <img
                  v-if="
                    group_prescription_medicine.finish_user &&
                    group_prescription_medicine.status != 'INATIVO'
                  "
                  :class="[
                    'mr-2',
                    group_prescription_medicine.finish_user.photo_url
                      ? 'user-photo-url'
                      : 'no-user-photo-url',
                  ]"
                  :src="
                    group_prescription_medicine.finish_user.photo_url
                      ? group_prescription_medicine.finish_user.photo_url
                      : require('../../../../assets/user.png')
                  "
                />
                <div>
                  <h6 class="legends mb-0">
                    PRESCRIÇÃO
                    <span
                      :class="[
                        handleClassStatusGroupPrescriptionMedicine(
                          group_prescription_medicine.status
                        ),
                      ]"
                    >
                      {{
                        {
                          PENDENTE: "PENDENTE",
                          CANCELADO: "CANCELADA",
                          FINALIZADO: "FINALIZADA",
                          INATIVO: "APAGADA",
                        }[group_prescription_medicine.status] || ""
                      }}
                    </span>
                    <span
                      v-if="
                        group_prescription_medicine.finish_user &&
                        group_prescription_medicine.status != 'INATIVO'
                      "
                    >
                      POR
                    </span>
                  </h6>
                  <h6
                    v-if="
                      group_prescription_medicine.finish_user &&
                      group_prescription_medicine.status != 'INATIVO'
                    "
                    class="legends worksansr mb-0"
                  >
                    {{
                      professionalClassCouncilValue({
                        id: group_prescription_medicine.finish_user
                          .professional_class_council_id,
                        name: group_prescription_medicine.finish_user.name,
                        value:
                          group_prescription_medicine.finish_user
                            .professional_class_council_value,
                        cpf: group_prescription_medicine.finish_user.cpf,
                        office: group_prescription_medicine.finish_user.office,
                      })
                    }}
                  </h6>
                </div>
              </div>
              <!-- APRAZAMENTO -->
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 d-flex align-items-center"
              >
                <img
                  v-if="
                    !group_prescription_medicine.user_finish_prescription_medicine_time ||
                    group_prescription_medicine.status_prescription_medicine_time ==
                      'PENDENTE'
                  "
                  class="mr-2 no-user-photo-url"
                  :src="require('../../../../assets/user.png')"
                />
                <img
                  v-if="
                    group_prescription_medicine.user_finish_prescription_medicine_time &&
                    group_prescription_medicine.status_prescription_medicine_time !=
                      'INATIVO'
                  "
                  :class="[
                    'mr-2',
                    group_prescription_medicine
                      .user_finish_prescription_medicine_time.photo_url
                      ? 'user-photo-url'
                      : 'no-user-photo-url',
                  ]"
                  :src="
                    group_prescription_medicine
                      .user_finish_prescription_medicine_time.photo_url
                      ? group_prescription_medicine
                          .user_finish_prescription_medicine_time.photo_url
                      : require('../../../../assets/user.png')
                  "
                />
                <div>
                  <h6 class="legends mb-0">
                    APRAZAMENTO
                    <span
                      :class="[
                        handleClassStatusGroupPrescriptionMedicine(
                          group_prescription_medicine.status_prescription_medicine_time
                        ),
                      ]"
                    >
                      {{
                        {
                          PENDENTE: "PENDENTE",
                          CANCELADO: "CANCELADO",
                          FINALIZADO: "FINALIZADO",
                          INATIVO: "APAGADO",
                        }[
                          group_prescription_medicine
                            .status_prescription_medicine_time
                        ] || ""
                      }}
                    </span>
                    <span
                      v-if="
                        group_prescription_medicine.user_finish_prescription_medicine_time &&
                        group_prescription_medicine.status_prescription_medicine_time !=
                          'INATIVO'
                      "
                    >
                      POR
                    </span>
                  </h6>
                  <h6
                    v-if="
                      group_prescription_medicine.user_finish_prescription_medicine_time &&
                      group_prescription_medicine.status_prescription_medicine_time !=
                        'INATIVO'
                    "
                    class="legends worksansr mb-0"
                  >
                    {{
                      professionalClassCouncilValue({
                        id: group_prescription_medicine
                          .user_finish_prescription_medicine_time
                          .professional_class_council_id,
                        name: group_prescription_medicine
                          .user_finish_prescription_medicine_time.name,
                        value:
                          group_prescription_medicine
                            .user_finish_prescription_medicine_time
                            .professional_class_council_value,
                        cpf: group_prescription_medicine
                          .user_finish_prescription_medicine_time.cpf,
                        office:
                          group_prescription_medicine
                            .user_finish_prescription_medicine_time.office,
                      })
                    }}
                  </h6>
                </div>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="row">
              <div
                v-if="group_prescription_medicine.status == 'FINALIZADO'"
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
              >
                <h6 class="status-center color-green check-text-center">
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  Prescrição finalizada com assinatura eletrônica
                </h6>
                <p v-if="group_prescription_medicine.certificate">
                  <span class="p-2 v-danger">{{
                    group_prescription_medicine.certificate
                  }}</span>
                </p>
                <h6
                  class="status-center color-green check-text-center"
                  v-if="
                    group_prescription_medicine.status_prescription_medicine_time ==
                    'FINALIZADO'
                  "
                >
                  <i class="fas fa-exclamation-circle mr-1"></i>
                  Aprazamento finalizado com assinatura eletrônica
                </h6>

                <span
                  v-if="group_prescription_medicine.technical_responsible == 1"
                  class="validated"
                >
                  Prescrição validada pelo responsável técnico:
                  {{ group_prescription_medicine.technical_user_name }}
                </span>
                <span
                  v-if="group_prescription_medicine.technical_responsible == 0"
                  class="not-validated"
                >
                  Prescrição não validada por um responsável técnico!
                </span>

                <p
                  v-if="
                    group_prescription_medicine.prescription_medicine_time_certificate
                  "
                >
                  <span class="p-2 v-danger">{{
                    group_prescription_medicine.prescription_medicine_time_certificate
                  }}</span>
                </p>
              </div>

              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-left"
              >
                <v-btn
                  v-if="
                    permission('write', 'resident_medical_prescription') &&
                    group_prescription_medicine.issetPrescriptionMedicineTime &&
                    group_prescription_medicine.status != 'INATIVO'
                  "
                  @click="
                    handleModalDuplicateGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                  class="btn-duplicate m-1"
                >
                  <i
                    :class="[
                      'fas fa-copy text-twenty',
                      width < 600 ? 'mr-0 ' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">DUPLICAR</span>
                </v-btn>
                <v-btn
                  @click="handlePrint(group_prescription_medicine)"
                  class="btn-print m-1"
                >
                  <i
                    :class="[
                      'fas fa-print text-twenty',
                      width < 600 ? 'mr-0' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">IMPRIMIR</span>
                </v-btn>
                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_medicine.status != 'CANCELADO' &&
                    group_prescription_medicine.status != 'INATIVO'
                  "
                  @click="
                    handleModalUpdateGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                  class="btn-edit m-1"
                >
                  <i
                    :class="[
                      'fas fa-pencil-alt text-twenty',
                      width < 600 ? 'mr-0' : 'mr-2',
                    ]"
                  ></i>
                  <span v-if="width > 600">EDITAR</span>
                </v-btn>
                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_medicine.status != 'INATIVO' &&
                    group_prescription_medicine.status != 'CANCELADO'
                  "
                  @click="
                    handleModalDeleteGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                  class="btn-delete m-1"
                >
                  <i
                    :class="[
                      'fas fa-trash text-twenty',
                      width < 600 ? 'mr-0' : 'mr-2',
                    ]"
                  >
                  </i>
                  <span v-if="width > 600">EXCLUIR</span>
                </v-btn>
                <b-modal
                  size="xl"
                  no-close-on-backdrop
                  hide-footer
                  :id="`history_prescription_${group_prescription_medicine.id}`"
                  title="HISTÓRICO"
                >
                  <History
                    show_text_no_data
                    entity_id_disabled
                    user_id_disabled
                    :entity_id="group_prescription_medicine.id"
                    table="group_prescription_medicine"
                    :toggle="open_history_prescription"
                  />
                </b-modal>
                <v-btn
                  class="btn-dateils ml-2"
                  @click="
                    handleModalHistoryPrescription(
                      group_prescription_medicine.id
                    )
                  "
                >
                  <i class="fas fa-history mr-1 mr-2 text-twenty"></i> HISTÓRICO
                </v-btn>
                <b-modal
                  size="lg"
                  no-close-on-backdrop
                  hide-footer
                  :id="`attachments_prescription_${group_prescription_medicine.id}`"
                  title="ANEXOS"
                >
                  <Attachments
                    :group_prescription_medicine_id="
                      group_prescription_medicine.id
                    "
                  />
                </b-modal>
                <v-btn
                  v-if="permission('write', 'resident_medical_prescription')"
                  class="v-success ml-2"
                  @click="
                    handleModalAttachmentsPrescription(
                      group_prescription_medicine.id
                    )
                  "
                >
                  <i class="fas fa-folder mr-1 mr-2 text-twenty"></i> ANEXOS
                </v-btn>
                <b-modal
                  size="lg"
                  no-close-on-backdrop
                  hide-footer
                  :id="`general_information_prescription_${group_prescription_medicine.id}`"
                  title="INFORMAÇÕES GERAIS"
                >
                  <GeneralInformation
                    :group_prescription_medicine_id="
                      group_prescription_medicine.id
                    "
                  />
                </b-modal>
                <v-btn
                  class="btn-edit ml-2"
                  @click="
                    handleModalGeneralInformation(
                      group_prescription_medicine.id
                    )
                  "
                >
                  <i class="fas fa-edit mr-1 mr-2 text-twenty"></i>
                  INFORMAÇÕES GERAIS
                </v-btn>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 check-text-right"
              >
                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_medicine.status != 'INATIVO' &&
                    group_prescription_medicine.status != 'CANCELADO'
                  "
                  @click="
                    handleModalAddPrescriptionMedicine(
                      group_prescription_medicine,
                      key_group
                    )
                  "
                  class="btn-two-add m-1"
                  ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
                  MEDICAMENTO
                </v-btn>
                <v-btn
                  v-if="
                    permission('edit', 'resident_medical_prescription') &&
                    group_prescription_medicine.issetPrescriptionMedicineTime &&
                    group_prescription_medicine.status == 'PENDENTE'
                  "
                  @click="
                    handleModalFinishGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                  class="btn-save m-1"
                >
                  <i class="fas fa-check mr-2 text-twenty"></i>FINALIZAR
                </v-btn>
                <ButtonGenerateCertificate
                  v-if="group_prescription_medicine.data_base64"
                  :id="group_prescription_medicine.id"
                  :data_base64="group_prescription_medicine.data_base64"
                />
              </div>
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalDuplicateGroupPrescriptionMedicine_${group_prescription_medicine.id}`"
                title="DUPLICAR PRESCRIÇÃO"
              >
                <GroupMedicineDuplicate
                  :id="group_prescription_medicine.id"
                  :resident_name="group_prescription_medicine.resident_name"
                  v-on:duplicate="
                    handleDuplicateGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                />
              </b-modal>
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalUpdateGroupPrescriptionMedicine_${group_prescription_medicine.id}`"
                title="EDITAR PRESCRIÇÃO"
              >
                <GroupMedicineView
                  :id="group_prescription_medicine.id"
                  :resident_name="group_prescription_medicine.resident_name"
                  :start_date="group_prescription_medicine.start_date"
                  :end_date="group_prescription_medicine.end_date"
                  :resident_id="resident_id"
                  v-on:update="
                    handleUpdateGroupPrescriptionMedicine(
                      group_prescription_medicine.id,
                      key_group
                    )
                  "
                  v-on:cancel="
                    $bvModal.hide(
                      `modalUpdateGroupPrescriptionMedicine_${group_prescription_medicine.id}`
                    )
                  "
                />
              </b-modal>
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalFinishGroupPrescriptionMedicine_${group_prescription_medicine.id}`"
                title="FINALIZAR"
              >
                <GroupMedicineFinish
                  :id="group_prescription_medicine.id"
                  :start_date="group_prescription_medicine.start_date"
                  :end_date="group_prescription_medicine.end_date"
                  v-on:finish="
                    handleFinishGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                />
              </b-modal>
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalDeleteGroupPrescriptionMedicine_${group_prescription_medicine.id}`"
                title="EXCLUIR PRESCRIÇÃO"
              >
                <GroupMedicineDelete
                  :id="group_prescription_medicine.id"
                  v-on:delete="
                    handleDeleteGroupPrescriptionMedicine(
                      group_prescription_medicine.id
                    )
                  "
                />
              </b-modal>

              <div class="col-md-12">
                <confirmation-dialog
                  certificate
                  validate
                  v-if="
                    group_prescription_medicine.status == 'FINALIZADO' &&
                    group_prescription_medicine.technical_responsible == 0 &&
                    userIsTechnicalResponsible
                  "
                  header-class=""
                  message-title="VALIDAR PRESCRIÇÃO"
                  message-body="Deseja realmente Validar essa evolução?"
                  open-class="btn-modern btn-modern-save"
                  open-left-icon="fas fa-check"
                  open-text="VALIDAR PRESCRIÇÃO"
                  @yes="validatePrescription(group_prescription_medicine.id)"
                />
              </div>

              <div class="col-md-12">
                <LinkVerLocalizacaoRegistro
                  :item="group_prescription_medicine"
                />
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <v-expansion-panels
                  v-model="panel_prescription_medicine"
                  hover
                  multiple
                  tile
                >
                  <v-expansion-panel
                    v-for="(
                      item, key_medicine
                    ) in group_prescription_medicine.prescription_medicines"
                    :key="key_medicine"
                  >
                    <v-expansion-panel-header class="medidine">
                      <div class="row">
                        <div
                          class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-12 d-flex justify-content-center align-items-center"
                        >
                          <i class="fas fa-capsules fa-2x color-blue"></i>
                        </div>
                        <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12">
                          <h6 class="mb-0 color-black check-text-center">
                            {{ item.medicine_name }}
                          </h6>
                          <h6 class="worksansr break-word check-text-center">
                            {{ item.medicine_active_ingredient }}
                          </h6>
                          <div class="d-flex residenttop-content">
                            <h6
                              class="btn-pendent"
                              v-if="
                                item.type_of_recipe_name ==
                                'CONTROLE ESPECIAL - 2 VIAS'
                              "
                            >
                              CONTROLE ESPECIAL
                            </h6>
                            <h6
                              class="btn-finish"
                              v-if="
                                item.type_of_recipe_name !=
                                'CONTROLE ESPECIAL - 2 VIAS'
                              "
                            >
                              {{ item.type_of_recipe_name }}
                            </h6>
                          </div>
                          <h6
                            class="color-deleted text-thirteen check-text-center"
                            v-if="
                              item.prescription_medicine_status == 'EXCLUIDO'
                            "
                          >
                            MEDICAMENTO EXCLUIDO NO DIA
                            {{ formatDate(item.updated_at, false) }}.
                            <br />
                            <span>
                              NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                              {{ formatDate(item.end, false) }}!</span
                            >
                          </h6>
                          <h6
                            class="color-edit text-thirteen check-text-center"
                            v-if="item.edited == 1"
                          >
                            MEDICAMENTO EDITADO NO DIA
                            {{ formatDate(item.edited_date, false) }}.
                            <br />
                            <span class="color-deleted">
                              NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                              {{ formatDate(item.end, false) }}!
                            </span>
                          </h6>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 d-flex check-justifique-right align-items-center pr-5"
                        >
                          <div>
                            <h6 class="mb-0 check-text-right">
                              {{ item.medicine_amount_of_times_name }}
                            </h6>
                            <h6 class="mb-0 worksansr check-text-right">
                              {{ handleDuration(item.duration) }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="row mt-3">
                        <div
                          class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12"
                        >
                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.medicine_list"
                          >
                            LISTA:
                            {{ item.medicine_list }}
                          </p>
                          <p class="mb-0 worksansr legends">
                            Via de administração:
                            {{ item.route_of_administration_name }}
                          </p>
                          <p class="mb-0 worksansr legends">
                            Frequência:
                            {{ handleFrequency(item.frequency) }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.frequency != 'EVENTUAL'"
                          >
                            Repetição:
                            {{ handleEvery(item.every, item.frequency) }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.frequency == 'SEMANAL'"
                          >
                            Dias da semana:
                            {{ item.dom && "DOM" }}
                            {{ item.seg && "SEG" }}
                            {{ item.ter && "TER" }}
                            {{ item.qua && "QUA" }}
                            {{ item.qui && "QUI" }}
                            {{ item.sex && "SEX" }}
                            {{ item.sab && "SAB" }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.medicine_amount_of_times_name"
                          >
                            Quantidade diária:
                            {{ item.medicine_amount_of_times_name }}
                          </p>
                          <div
                            class="col-xl-4 col-lg-7 col-md-12 col-sm-12 col-12 v-clean mt-1 mb-1 p-1"
                            v-if="
                              item.medicine_amount_of_times_type == 'SHIFTS'
                            "
                          >
                            <div class="row">
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0"
                              >
                                <h6 class="mb-0">TURNO</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pt-0 pb-0 pl-0"
                              >
                                <h6 class="mb-0">QUANTIDADE</h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.dawn && item.dawn_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  MADRUGADA
                                </h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0 pl-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_dawn_quantity
                                      ? `${item.drops_dawn_quantity} GOTA(S)`
                                      : item.ui_dawn_quantity
                                      ? `${item.ui_dawn_quantity} UI`
                                      : item.dawn_quantity
                                  }}
                                  {{
                                    item.drops_dawn_quantity
                                      ? ""
                                      : item.ui_dawn_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.morning && item.morning_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">MANHÃ</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0 pl-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_morning_quantity
                                      ? `${item.drops_morning_quantity} GOTA(S)`
                                      : item.ui_morning_quantity
                                      ? `${item.ui_morning_quantity} UI`
                                      : item.morning_quantity
                                  }}
                                  {{
                                    item.drops_morning_quantity
                                      ? ""
                                      : item.ui_morning_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.afternoon && item.afternoon_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">TARDE</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_afternoon_quantity
                                      ? `${item.drops_afternoon_quantity} GOTA(S)`
                                      : item.ui_afternoon_quantity
                                      ? `${item.ui_afternoon_quantity} UI`
                                      : item.afternoon_quantity
                                  }}
                                  {{
                                    item.drops_afternoon_quantity
                                      ? ""
                                      : item.ui_afternoon_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation}(S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.night && item.night_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">NOITE</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_night_quantity
                                      ? `${item.drops_night_quantity} GOTA(S)`
                                      : item.ui_night_quantity
                                      ? `${item.ui_night_quantity} UI`
                                      : item.night_quantity
                                  }}
                                  {{
                                    item.drops_night_quantity
                                      ? ""
                                      : item.ui_night_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.shift_5 && item.shift_5_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">5º</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_shift_5_quantity
                                      ? `${item.drops_shift_5_quantity} GOTA(S)`
                                      : item.ui_shift_5_quantity
                                      ? `${item.ui_shift_5_quantity} UI`
                                      : item.shift_5_quantity
                                  }}
                                  {{
                                    item.drops_shift_5_quantity
                                      ? ""
                                      : item.ui_shift_5_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.shift_6 && item.shift_6_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">6º</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_shift_6_quantity
                                      ? `${item.drops_shift_6_quantity} GOTA(S)`
                                      : item.ui_shift_6_quantity
                                      ? `${item.ui_shift_6_quantity} UI`
                                      : item.shift_6_quantity
                                  }}
                                  {{
                                    item.drops_shift_6_quantity
                                      ? ""
                                      : item.ui_shift_6_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.shift_7 && item.shift_7_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">7º</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_shift_7_quantity
                                      ? `${item.drops_shift_7_quantity} GOTA(S)`
                                      : item.ui_shift_7_quantity
                                      ? `${item.ui_shift_7_quantity} UI`
                                      : item.shift_7_quantity
                                  }}
                                  {{
                                    item.drops_shift_7_quantity
                                      ? ""
                                      : item.ui_shift_7_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                            <div
                              class="row"
                              v-if="item.shift_8 && item.shift_8_quantity"
                            >
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="worksansr mb-0 legends">8º</h6>
                              </div>
                              <div
                                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 pb-0"
                              >
                                <h6 class="mb-0 worksansr legends">
                                  {{
                                    item.drops_shift_8_quantity
                                      ? `${item.drops_shift_8_quantity} GOTA(S)`
                                      : item.ui_shift_8_quantity
                                      ? `${item.ui_shift_8_quantity} UI`
                                      : item.shift_8_quantity
                                  }}
                                  {{
                                    item.drops_shift_8_quantity
                                      ? ""
                                      : item.ui_shift_8_quantity
                                      ? ""
                                      : `${item.unit_of_measurement_abbreviation} (S)`
                                  }}
                                </h6>
                              </div>
                            </div>
                          </div>

                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              (item.duration == 'ATE_A_DATA' ||
                                item.duration == 'DURANTE_UM_PERIODO')
                            "
                          >
                            Data de início:
                            {{ formatDate(item.start_date, false) }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.frequency != 'EVENTUAL'"
                          >
                            Duração:
                            {{ handleDuration(item.duration) }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              item.duration == 'DURANTE_UM_PERIODO'
                            "
                          >
                            Período de:
                            {{ item.duration_time }} dia(s)
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.frequency != 'EVENTUAL' &&
                              item.duration == 'ATE_A_DATA'
                            "
                          >
                            Data de término:
                            {{ formatDate(item.end_date, false) }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="
                              item.medicine_amount_of_times_type == 'DAY' ||
                              item.frequency == 'EVENTUAL'
                            "
                          >
                            Quantidade
                            {{
                              item.drops_quantity
                                ? `${item.drops_quantity} GOTA(S)`
                                : item.ui_quantity
                                ? `${item.ui_quantity} UI`
                                : item.quantity
                            }}
                            {{
                              item.drops_quantity
                                ? ""
                                : item.ui_quantity
                                ? ""
                                : `${item.unit_of_measurement_name} (S)`
                            }}
                          </p>
                          <p
                            class="mb-0 worksansr legends"
                            v-if="item.instruction"
                          >
                            Instrução:
                            {{ item.instruction }}
                          </p>
                          <h6 class="mt-2 legends">
                            MEDICAMENTO CADASTRADO POR:
                            {{ item.user_name }}
                          </h6>
                          <p class="mt-0 mb-0" v-if="item.init">
                            Medicamento inicia:
                            {{ formatDate(item.init, false) }}
                          </p>
                          <p
                            class="mt-0 mb-0"
                            v-if="
                              item.prescription_medicine_status == 'EXCLUIDO' &&
                              item.end_medicine
                            "
                          >
                            Medicamento termina:
                            {{ formatDate(item.end_medicine, false) }}
                          </p>
                          <p
                            class="mt-0 mb-0"
                            v-if="item.edited == 1 && item.end_medicine"
                          >
                            Medicamento termina:
                            {{ formatDate(item.end_medicine, false) }}
                          </p>
                          <p class="mt-2">
                            Cadastrado: {{ formatDate(item.created_at, false) }}
                            <br />
                            Última alteração:
                            {{ formatDate(item.updated_at, false) }}
                          </p>
                          <b-modal
                            size="xl"
                            no-close-on-backdrop
                            hide-footer
                            :id="`history_medicine_${item.id}`"
                            title="HISTÓRICO"
                          >
                            <History
                              show_text_no_data
                              entity_id_disabled
                              user_id_disabled
                              :entity_id="item.id"
                              table="prescription_medicine"
                              :toggle="open_history_medicine"
                            />
                          </b-modal>
                          <v-btn
                            class="btn-dateils"
                            @click="handleModalHistoryMedicine(item.id)"
                          >
                            <i class="fas fa-history mr-2 text-twenty"></i>
                            HISTÓRICO
                          </v-btn>
                          <div>
                            <LinkVerLocalizacaoRegistro :item="item" />
                          </div>
                        </div>

                        <div
                          :class="[
                            'col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center',
                            item.status == 'FINALIZADO',
                          ]"
                        >
                          <div class="row v-clean d-flex align-items-end">
                            <div
                              v-if="item.frequency != 'EVENTUAL'"
                              class="col-xl-4 col-lg-3 col-md-6 col-sm-6 col-6"
                            >
                              <h6 class="worksansr">HORÁRIO</h6>
                              <p
                                class="mb-0 text-for"
                                v-for="prescription_medicine_time in item.prescription_medicine_time"
                                :key="prescription_medicine_time.id"
                              >
                                {{
                                  prescription_medicine_time.time
                                    ? prescription_medicine_time.time
                                    : "Não informado"
                                }}
                              </p>
                            </div>
                            <div
                              class="col-xl-4 col-lg-3 col-md-6 col-sm-6 col-6"
                            >
                              <h6 class="worksansr">QUANTIDADE</h6>
                              <p
                                class="mb-0 text-for"
                                v-for="prescription_medicine_time in item.prescription_medicine_time"
                                :key="prescription_medicine_time.id"
                              >
                                {{
                                  prescription_medicine_time.drops
                                    ? `${prescription_medicine_time.drops} GOTA(S)`
                                    : prescription_medicine_time.ui
                                    ? `${prescription_medicine_time.ui} UI`
                                    : prescription_medicine_time.quantity
                                }}
                                {{
                                  prescription_medicine_time.drops
                                    ? ""
                                    : prescription_medicine_time.ui
                                    ? ""
                                    : ` ${prescription_medicine_time.unit_of_measurement_value}(S)`
                                }}
                              </p>
                            </div>

                            <div
                              class="col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end p-1"
                            >
                              <v-btn
                                v-if="
                                  permission(
                                    'edit',
                                    'resident_medical_prescription'
                                  ) &&
                                  item.status != 'CANCELADO' &&
                                  item.status != 'INATIVO' &&
                                  item.prescription_medicine_status ==
                                    'ATIVO' &&
                                  item.edited == 0
                                "
                                @click="
                                  handlePrescriptionMedicine(item, key_group)
                                "
                                class="btn-edit m-1"
                              >
                                <i
                                  :class="[
                                    'fas fa-pencil-alt text-twenty',
                                    width < 600 ? 'mr-0' : 'mr-2',
                                  ]"
                                ></i>
                                <span v-if="width > 600"> EDITAR</span>
                              </v-btn>
                              <v-btn
                                v-if="
                                  permission(
                                    'edit',
                                    'resident_medical_prescription'
                                  ) &&
                                  item.status != 'CANCELADO' &&
                                  item.status != 'INATIVO' &&
                                  item.prescription_medicine_status ==
                                    'ATIVO' &&
                                  item.edited == 0
                                "
                                @click="
                                  handleModalDeletePrescriptionMedicine(
                                    item,
                                    item.id,
                                    key_group
                                  )
                                "
                                class="btn-delete m-1"
                              >
                                <i
                                  :class="[
                                    'fas fa-trash text-twenty',
                                    width < 600 ? 'mr-0' : 'mr-2',
                                  ]"
                                ></i>
                                <span v-if="width > 600"> EXCLUIR</span>
                              </v-btn>
                            </div>
                          </div>
                        </div>

                        <b-modal
                          size="lg"
                          no-close-on-backdrop
                          hide-footer
                          :id="`modalPrescriptionMedicine_${item.id}`"
                          title="EDITAR MEDICAMENTO"
                        >
                          <MedicineView
                            :prescription_medicine="prescription_medicine"
                            :group_prescription_medicine="
                              group_prescription_medicine
                            "
                            v-on:update="
                              handleUpdatePrescriptionMedicine(
                                item.id,
                                key_medicine
                              )
                            "
                          />
                        </b-modal>
                        <b-modal
                          size="md"
                          no-close-on-backdrop
                          hide-footer
                          :id="`modalDeletePrescriptionMedicine_${item.id}`"
                          title="EXCLUIR MEDICAMENTO"
                        >
                          <MedicineDelete
                            :id="item.id"
                            :prescription_medicine="prescription_medicine"
                            :group_prescription_medicine="
                              group_prescription_medicine
                            "
                            v-on:delete="
                              handleDeletePrescriptionMedicine(
                                item.id,
                                key_medicine
                              )
                            "
                          />
                        </b-modal>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <b-pagination
          align="right"
          v-if="group_prescription_medicines.length > 0"
          @input="paginate()"
          v-model="page"
          :total-rows="total"
          :per-page="5"
        />
      </div>
    </b-overlay>
  </div>
</template>

<script>
import History from "../../../../templates/History/Prescription";

import ErrorsMessages from "../../../../templates/Components/ErrorsMessages";

import ButtonGenerateCertificate from "../../../../templates/Components/ButtonGenerateCertificate";

import LinkVerLocalizacaoRegistro from "../../../../templates/Components/LinkVerLocalizacaoRegistro";

import ConfirmationDialog from "../../../../templates/Components/ConfirmationDialog.vue";

import GroupMedicineCreate from "../../../../templates/Prescription/GroupMedicine/Create";

import MedicineCreate from "../../../../templates/Prescription/Medicine/Create";

import MedicineView from "../../../../templates/Prescription/Medicine/View";

import GroupMedicineDuplicate from "../../../../templates/Prescription/GroupMedicine/Duplicate";

import GroupMedicineView from "../../../../templates/Prescription/GroupMedicine/View";

import GroupMedicineFinish from "../../../../templates/Prescription/GroupMedicine/Finish";

import GroupMedicineDelete from "../../../../templates/Prescription/GroupMedicine/Delete";

import MedicineDelete from "../../../../templates/Prescription/Medicine/Delete";

import Attachments from "../../../../templates/Prescription/Attachments";

import GeneralInformation from "../../../../templates/Prescription/GeneralInformation";

import api from "../../../../services/api";

import routes from "../../../../routes";

import permission from "../../../../lib/permission";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import toast from "../../../../lib/ToastNotification";

import { userData } from "../../../../lib/functions";

import BRyHUB from "../../../../lib/BRy/hub";

export default {
  name: "Prescriptions",
  components: {
    History,
    GroupMedicineCreate,
    MedicineCreate,
    MedicineView,
    GroupMedicineDuplicate,
    GroupMedicineView,
    GroupMedicineFinish,
    GroupMedicineDelete,
    MedicineDelete,
    Attachments,
    GeneralInformation,
    ErrorsMessages,
    ButtonGenerateCertificate,
    LinkVerLocalizacaoRegistro,
    ConfirmationDialog,
  },

  props: {
    user_logged: { type: [Object, Boolean], default: null },
  },

  data() {
    return {
      user_id: "",

      userIsTechnicalResponsible: false,

      open_history_prescription: false,

      open_history_medicine: false,

      page: 1,

      total: 0,

      isActiveFilter: false,

      start_date: "",

      end_date: "",

      resident_id: "",

      resident: {},

      prints: [],

      status: "ALL",

      group_prescription_medicine_prints: [],

      group_prescription_medicines: [],

      group_prescription_medicine: {},

      prescription_medicine: {},

      errors: [],

      errorsCertificate: [],

      loading: false,

      loadingCertificate: false,

      showPrint: false,

      keyGroup: 0,

      keyMedicine: 0,

      width: window.screen.width,

      panel_group_prescription_medicine: [],

      panel_prescription_medicine: [],
    };
  },

  created() {
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  methods: {
    permission,
    formatDate,
    professionalClassCouncilValue,

    handleModalSignature(id) {
      this.$bvModal.show(`modalSignature_${id}`);
    },

    handleClassStatusGroupPrescriptionMedicine(status) {
      return (
        {
          PENDENTE: "text-warning",
          CANCELADO: "text-cancel",
          FINALIZADO: "text-sucess",
          INATIVO: "text-inativi",
        }[status] || ""
      );
    },

    handleModalHistoryPrescription(id) {
      this.$bvModal.show(`history_prescription_${id}`);
      setTimeout(() => (this.open_history_prescription = true), 200);
    },

    handleModalAttachmentsPrescription(id) {
      this.$bvModal.show(`attachments_prescription_${id}`);
    },

    handleModalGeneralInformation(id) {
      this.$bvModal.show(`general_information_prescription_${id}`);
    },

    handleModalHistoryMedicine(id) {
      this.$bvModal.show(`history_medicine_${id}`);
      setTimeout(() => (this.open_history_medicine = true), 200);
    },

    handleOnResize() {
      this.width = window.innerWidth;
    },

    handleModalAddGroupPrescriptionMedicine() {
      this.$bvModal.show("modalAddGroupPrescriptionMedicine");
    },

    handleModalAddPrescriptionMedicine(item, key) {
      this.group_prescription_medicine = item;
      this.keyGroup = key;
      this.$bvModal.show("modalAddPrescriptionMedicine");
    },

    handleModalDuplicateGroupPrescriptionMedicine(id) {
      this.$bvModal.show(`modalDuplicateGroupPrescriptionMedicine_${id}`);
    },

    handleDuplicateGroupPrescriptionMedicine(id) {
      this.$bvModal.hide(`modalDuplicateGroupPrescriptionMedicine_${id}`);
      this.paginate(true, 0);
    },

    handleModalUpdateGroupPrescriptionMedicine(id) {
      this.$bvModal.show(`modalUpdateGroupPrescriptionMedicine_${id}`);
    },

    handleUpdateGroupPrescriptionMedicine(id, key) {
      this.$bvModal.hide(`modalUpdateGroupPrescriptionMedicine_${id}`);
      this.paginate(true, key);
    },

    handleModalFinishGroupPrescriptionMedicine(id) {
      this.$bvModal.show(`modalFinishGroupPrescriptionMedicine_${id}`);
    },

    handleFinishGroupPrescriptionMedicine(id) {
      this.$bvModal.hide(`modalFinishGroupPrescriptionMedicine_${id}`);
      this.paginate();
    },

    handleModalDeleteGroupPrescriptionMedicine(id) {
      this.$bvModal.show(`modalDeleteGroupPrescriptionMedicine_${id}`);
    },

    handleDeleteGroupPrescriptionMedicine(id) {
      this.$bvModal.hide(`modalDeleteGroupPrescriptionMedicine_${id}`);
      this.paginate();
    },

    handleCreateGroupPrescriptionMedicine() {
      this.$bvModal.hide("modalAddGroupPrescriptionMedicine");
      this.paginate(true, 0);
    },

    handleCreatePrescriptionMedicine() {
      this.$bvModal.hide("modalAddPrescriptionMedicine");
      this.paginate(true, this.keyGroup);
    },

    handleUpdatePrescriptionMedicine(id, key) {
      this.$bvModal.hide(`modalPrescriptionMedicine_${id}`);
      this.paginate(true, this.keyGroup, true, key);
    },

    handleDeletePrescriptionMedicine(id, key) {
      this.$bvModal.hide(`modalDeletePrescriptionMedicine_${id}`);
      this.paginate(true, this.keyGroup, true, key);
    },

    handleFrequency(frequency) {
      let frequencys = {
        DIARIO: "DIÁRIO",
        SEMANAL: "SEMANAL",
        MENSAL: "MENSAL",
        ANUAL: "ANUAL",
        EVENTUAL: "EVENTUAL",
        default: "NÃO ENCONTRADO!!!",
      };

      return frequencys[frequency] || frequencys.default;
    },

    handleEvery(every, frequency) {
      let frequencys = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      return `A CADA ${every} ${frequencys[frequency]}`;
    },

    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { user } = userData();

      this.user_id = user.id;

      if (user.technical_responsible == 1) {
        this.getUserIsTechnicalResponsible();
      }

      await this.paginate();
    },

    async paginate(
      keyGroup = null,
      valueGoup = 0,
      keyMedicine = null,
      valueMedicine = 0
    ) {
      try {
        this.loading = true;
        this.panel_group_prescription_medicine = [];
        this.panel_prescription_medicine = [];
        this.group_prescription_medicines = [];
        this.errors = [];

        const { resident_id, status, start_date, end_date, page } = this;

        let params = {
          resident_id,
          status,
          start_date,
          end_date,
          page,
          type: "NORMAL",
        };

        const response = await api.get(
          "/rest-home/resident/group-prescription-medicines",
          {
            params,
          }
        );

        const { error, errors, group_prescription_medicines, total } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.isActiveFilter = false;
          this.group_prescription_medicines = group_prescription_medicines;

          let group_prescription_medicine_prints = [];
          for (let item of group_prescription_medicines) {
            if (
              item.status == "FINALIZADO" &&
              item.status_prescription_medicine_time == "FINALIZADO"
            ) {
              group_prescription_medicine_prints.push({
                id: item.id,
                resident_name: item.resident_name,
                start_date: item.start_date,
                end_date: item.end_date,
              });
            }
          }

          this.group_prescription_medicine_prints =
            group_prescription_medicine_prints;
          this.total = total;
          if (keyGroup) {
            this.panel_group_prescription_medicine = [valueGoup];
            if (keyMedicine) {
              this.panel_prescription_medicine = [valueMedicine];
            }
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handlePrescriptionMedicine(item, key) {
      this.prescription_medicine = item;
      this.keyGroup = key;
      this.$bvModal.show(`modalPrescriptionMedicine_${item.id}`);
    },

    handleModalDeletePrescriptionMedicine(item, id, key) {
      this.prescription_medicine = item;
      this.keyGroup = key;
      this.$bvModal.show(`modalDeletePrescriptionMedicine_${id}`);
    },

    handleChangeQuantity() {
      this.paginate();
    },

    handleFilter() {
      this.paginate();
      this.$bvModal.hide("imprimir");
    },

    handlePrint({ id }) {
      let route = this.$router.resolve({
        name: "group_prescription_medicine_print",
        params: { id },
      });

      window.open(route.href, "_blank");
    },

    handleOpenModalPrints() {
      this.$bvModal.show("prints");
      this.prints = [];
    },

    handlePrints() {
      let { prints } = this;

      if (prints.length == 0) {
        return toast("Informe ao menos uma prescrição", "error");
      }

      let ids = [];

      prints.map((print) => ids.push(print.id));

      let route = this.$router.resolve({
        name: "group_prescription_medicine_prints",
        params: { ids: ids.join(",") },
      });

      window.open(route.href, "_blank");
    },

    async getUserIsTechnicalResponsible() {
      try {
        this.loading = true;

        const type = "PRESCRICAO";

        let params = { type };

        let response = await api.get("/technical-responsible/user", { params });

        let { userIsTechnicalResponsible } = response.data;

        this.userIsTechnicalResponsible = userIsTechnicalResponsible;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async validatePrescription(id) {
      try {
        this.loading = true;

        let params = { id, table_name: "group_prescription_medicine" };

        let response = await api.put("/technical-responsible", params);

        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.paginate();

          await BRyHUB.authorize({ id, table: "group_prescription_medicine" });
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>

<style>
.prescription-medicine .medidine .name {
  margin-left: 10px;
  display: flex;
  flex-direction: column !important;
  justify-content: center;
}
.prescription-medicine .medidine .frequency {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-end;
}
.prescription-medicine .medidine .frequency strong {
  font-size: 18px;
}

.icon-photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 1px solid #22c55e;
}
</style>
